// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"custom-scroll___1GL5-"};